<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
    <!-- <CalendarToday /> -->
  </div>
</template>

<script>
// import CalendarToday from "vue-material-design-icons/CalendarToday.vue"

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiCalendarToday } from "@mdi/js"

export default {
  name: "CalendarTodayIcon",
  components: {
    SvgIcon
    // CalendarToday,
  },
  data() {
    return {
      path: mdiCalendarToday,
    }
  }
}
</script>
